import { render, staticRenderFns } from "./SalesStatistics.vue?vue&type=template&id=86b2e0e4&scoped=true&"
import script from "./SalesStatistics.vue?vue&type=script&lang=js&"
export * from "./SalesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SalesStatistics.vue?vue&type=style&index=0&id=86b2e0e4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./SalesStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b2e0e4",
  null
  
)

export default component.exports